import { render, staticRenderFns } from "./ImportSuppliersModal.vue?vue&type=template&id=a5afc4b0"
import script from "./ImportSuppliersModal.vue?vue&type=script&lang=js"
export * from "./ImportSuppliersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports